export default __webpack_public_path__ + "static/media/thumbs_up_white.ec4b0b92.svg";